import { PAYG_EVENTS } from '@/src/constants/analytics';
import { PAYX_SCREEN } from '@/src/constants/analytics-subjects';
import AnalyticsService from '@/src/services/analyticsService';
import {
  Display4,
  Link,
  P,
  Stack,
  Strong,
  TextLink,
} from '@ovotech/element-v5';
import React, { useEffect } from 'react';
import { PageWithoutNavigationAndSectionPadding } from '../Pages';
import { Card, Subheading } from './PayxHoldingPage.styled';

export const PayxHoldingPage = () => {
  useEffect(() => {
    AnalyticsService.dispatch(...PAYG_EVENTS.payxViewed());
  }, []);

  return (
    <PageWithoutNavigationAndSectionPadding
      title="Getting your account ready for you"
      analytics={{ name: PAYX_SCREEN }}
    >
      <Card>
        <Stack spaceBetween={6}>
          <Display4>Getting your account ready for you</Display4>
          <P size="lg">
            We're putting the finishing touches on your setup. You don't need to
            do a thing – we'll notify you as soon as you can use your account.
          </P>
          <div>
            <Subheading>
              <Strong>For Pay Monthly</Strong>
            </Subheading>
            <P size="lg">
              If you need to view your account details or billing information,
              please chat to us online.
            </P>
          </div>
          <div>
            <Subheading>
              <Strong>For Pay As You Go</Strong>
            </Subheading>
            <P size="lg">
              You can still add credit to your meter at any PayPoint, Payzone,
              or Post Office. You can also top up by calling{' '}
              <TextLink href="tel:03303035063">
                <Strong>0330 175 9669</Strong>
              </TextLink>
              .
            </P>
          </div>
          <Link
            opensInNewWindow
            href="https://www.ovoenergy.com/help?chat=1"
            iconRight="chevron-right"
          >
            Chat with us
          </Link>
        </Stack>
      </Card>
    </PageWithoutNavigationAndSectionPadding>
  );
};
